module.exports = __webpack_public_path__ + "img/regalo.e9b9266c.png";